import Archive from "../components/Archive/Archive";

export default function ArchivePage() {
	return <Archive />;
}
